'use strict';
import {settings} from '../../variables.js'
var angularTemplateBase = settings.angularTemplatesBase

angular.
module('auth')
.component('register', {
    templateUrl: angularTemplateBase+'auth/register.template.html?1',
    controller: ['$routeParams', '$location', '$cookies', 'User', function RegisterFormCtrl($routeParams, $location, $cookies, User) {
        var self = this;

        self.step = 'start';
        self.disable_btn = false;

        self.user = User.get({}, function(){
            if (self.user.id) {
                self.step = 'step_second';
            }
        });

        self.next_step = function(step){
            self.step = step;
        }

        self.create_user = function(step){
            self.disable_btn = true;

            if (!step) {
                step = 'step_second';
            }
            else {

            }

            if (self.user.id){
                self.user.$update(
                    function(response){
                        self.step = step;
                        self.disable_btn = false;
                    },
                    function(response){
                        self.errors = response.data;
                        self.disable_btn = false;
                    }
                )
            }
            else {
                self.user.$save(
                    function(response){
                        self.step = step;
                        self.disable_btn = false;
                    },
                    function(response){
                        self.errors = response.data;
                        self.disable_btn = false;
                    }
                )
            }


        }

    }]
})
;